module.exports = __webpack_public_path__ + "img/首 页.96faaf46.svg";